import Controller from '@ember/controller';

export default class AuthenticatedSettingsController extends Controller {}
